import TranslateWrapper, { translateWithVariables } from './TranslateWrapper';

export {
  TranslateWrapper,
  translateWithVariables
};

export default TranslateWrapper;